<template>
  <footer class="footer">
    <div>
      <button
        class="footer_download">使用Chrome或UC浏览器开启本站获得最佳体验
      </button>
    </div>
  </footer>
</template>

<script>
import { device, deviceType } from '@/utils'
export default {
  name: 'Footer',
  setup (props, { emit }) {
    const {
      IOS_URL,
      ANDROID_URL
    } = window.__CONFIG__

    const download = () => {
      const deviceName = device()
      switch (deviceName) {
        case deviceType.android:
          window.open(ANDROID_URL, '_self')
          break

        case deviceType.ios:
          window.open(IOS_URL, '_self')
          break

        case deviceType.pc:
          emit('download')
          break
      }
    }

    return {
      download
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  margin-top: -4px;
  background-color: #121212;

  &_download {
    width: 100%;
    font-family: Inter, Microsoft Sans serif;
    font-size: 12px;
    color: #9a9a9a;
    text-align: center;
    background-color: transparent;
    border: none;
    box-shadow: none;

    @media screen and (max-width: 320px) {
      padding: 5px 10px;
    }
  }
}
</style>
